import { SfLog } from '@app/adapters/logger'
import { subscribe } from '@app/adapters/cookie-consent'

const getLogRocket = async () => {
  //  Since this is an async operation it can potentially throw
  try {
    // Dynamically import LogRocket. This keeps it out of the main bundle. It is still prefetched though.
    const LogRocketModule = await import(
      /* webpackPrefetch: true, webpackChunkName: 'logrocket' */ 'logrocket'
    )
    return LogRocketModule.default
  } catch (e) {
    SfLog.error('LogRocket failed to load', {
      error: e,
    })
  }
}

const initLogRocket = async (data) => {
  const logRocket = await getLogRocket()
  const redactionClassName = 'elements-should-be-redacted'

  if (!logRocket || !data) return

  logRocket.init('gcmijm/silverfin', {
    dom: {
      privateClassNameBlocklist: [redactionClassName],
    },
    network: {
      responseSanitizer: (response) => {
        if (
          response.headers &&
          ('X-Redact-Network-Recording' in response.headers ||
            'x-redact-network-recording' in response.headers)
        ) {
          return {
            ...response,
            body: undefined,
          }
        }

        return response
      },
    },
  })
  logRocket.identify(data.identity, {
    firmId: data.firmId,
    firmName: data.firmName,
    firmCountry: data.firmCountry,
    email: data.email,
    admin: data.admin,
    staffAccess: data.staffAccess,
    silverfinInternal: data.silverfinInternal,
    external: data.external,
  })

  // should get loaded after heap
  logRocket.getSessionURL(function (sessionURL) {
    window.heap.track('LogRocket', { sessionURL: sessionURL })
  })
}

const deactivateLogRocket = async () => {
  const logRocket = await getLogRocket()
  if (!logRocket) return

  logRocket.uninstall()
}

const getContainerData = ($dom) => {
  const doc = $dom[0]
  const container = doc.querySelector("[data-behaviour~='session-replay']")

  return container?.dataset
}

// Initialization is dependent on the cookie banner AppConfig. If it's disabled,
// we should just initialize LogRocket without caring about cookie settings.
export default () => {
  onDomLoad(($dom) => {
    const data = getContainerData($dom)

    if (data?.ignoreCookieSettings === 'true') {
      initLogRocket(data)
    }
  })

  subscribe((payload) => {
    if (payload.logRocket) {
      initLogRocket(getContainerData($(document)))
    } else {
      deactivateLogRocket()
    }
  })

  return deactivateLogRocket
}
